<template>
  <div v-if="!this.authenticationStore.authenticated" class="container">
    <div v-if="errorMessage" class="alert alert-danger d-flex justify-content-between">
      <span><em class="align-middle material-icons">error_outlined</em> {{ errorMessage }}</span>
      <button aria-label="Close" class="btn-close" type="button" @click.prevent="errorMessage=''"></button>
    </div>
    <div class="row text-center gy-3 row-cols-1">
      <div class="col">
        <img alt="Logo" class="logo" src="../assets/logo.png">
      </div>
      <div class="col">
        <h3>Messdienerplanprogramm</h3>
        <h6>Bitte melde dich für den Zugriff erst an.</h6>
      </div>
    </div>
    <div class="container">
      <form class="row row-cols-1 g-3 login-form">
        <div class="col">
          <label class="form-label" for="username">Nutzername</label>
          <input id="username" v-model="this.loginForm.username" autofocus class="form-control" placeholder="Nutzername"
                 name="username" required type="text">
        </div>
        <div class="col">
          <label class="form-label" for="password">Passwort</label>
          <input id="password" v-model="this.loginForm.password" class="form-control" placeholder="Password" required
                 name="password" type="password">
        </div>
        <div class="form-check">
          <label class="form-check-label" for="rememberMe">Eingeloggt bleiben</label>
          <input id="rememberMe" v-model="this.loginForm.rememberMe" class="form-check-input" type="checkbox">
        </div>
        <div class="col">
          <button class="btn btn-primary mb-3" @click.prevent="login"><em class="align-middle material-icons">login</em>
            Login
          </button>
        </div>
      </form>
    </div>
  </div>
  <a v-else class="nav-link" @click="logout"><em class="align-middle material-icons">logout</em> Logout</a>
</template>

<script>
import {useAuthenticationStore} from "@/stores/authentication";

export default {
  name: "VueAuthentication",
  setup() {
    const authenticationStore = useAuthenticationStore();
    return {authenticationStore};
  },
  data: function () {
    return {
      loginForm: {
        username: "",
        password: "",
        rememberMe: true,
      },
      errorMessage: ""
    }
  },
  methods: {
    async login() {
      this.axios.post("/login/", this.loginForm).then(() => {
        this.authenticationStore.authenticated = true;
        this.authenticationStore.getCSRFToken();
      }).catch((e) => {
        this.errorMessage = e.response.data.detail;
      }).finally(() => {
        this.loginForm.username = this.loginForm.password = "";
        this.loginForm.rememberMe = true;
      });
    },
    async logout() {
      this.axios.post("/logout/").then(() => {
        this.authenticationStore.authenticated = false;
        this.authenticationStore.getCSRFToken();
      }).catch((e) => {
        console.log(e);
      })
    },
    async getSession() {
      this.axios.get('/session/').then(response => {
        this.authenticationStore.authenticated = response.data.isAuthenticated;
      }).catch(e => {
        console.log(e);
      });
    }
  },
  created() {
    this.getSession();
  }
}
</script>

<style scoped>
.login-form {
  width: 50%;
  min-width: 300px;
  margin: 0 auto;
}

a {
  cursor: pointer;
}

.logo {
  height: 80px;
}

.form-check {
  padding-left: calc(var(--bs-gutter-x) * .5 + 1.5em);
}
</style>